import React from 'react'

const InformationIcon = () => (
  <svg width="23" height="21" viewBox="0 0 23 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="23" height="21" rx="2" fill="#515151" fillOpacity="0.5" />
    <path d="M10.5996 12.2324L10.4561 5.62891H12.124L11.9873 12.2324H10.5996ZM11.2969 15.6504C10.9779 15.6504 10.7204 15.557 10.5244 15.3701C10.333 15.1833 10.2373 14.9372 10.2373 14.6318C10.2373 14.3219 10.333 14.0736 10.5244 13.8867C10.7204 13.6953 10.9779 13.5996 11.2969 13.5996C11.6113 13.5996 11.8643 13.6953 12.0557 13.8867C12.2516 14.0736 12.3496 14.3219 12.3496 14.6318C12.3496 14.9372 12.2516 15.1833 12.0557 15.3701C11.8643 15.557 11.6113 15.6504 11.2969 15.6504Z" fill="white" />
  </svg>
)

export default InformationIcon
